import React from 'react'
import { Button } from 'lib/ui/components'

interface Props {
  card: {
    type: string
    last4: string
    expiration: string
  }
  description: string
  /** Digital wallet the credential originates from, empty for a directly entered card. */
  walletLabel?: string
  isDisabled: boolean
  onDelete: () => void
}

export const Item = ({
  description,
  card,
  walletLabel,
  isDisabled,
  onDelete
}: Props) => {
  const cardTitle = 'Payment Method'

  return (
    <>
      <p><strong>{cardTitle}</strong></p>
      <div className='card'>
        <div className='address'>
          <div className='border-box'>
            <p><strong>{card.type}<br />**** **** **** {card.last4}</strong></p>
          </div>
        </div>
        <div className='address'>
          <div className='border-box'>
            {/* A wallet credential has no guaranteed expiration date - omit the line
                entirely rather than rendering a dangling "Expires". */}
            {card.expiration && <p>Expires {card.expiration}</p>}
            {walletLabel && <p>Saved from {walletLabel}</p>}
            {description && <p>{description}</p>}
          </div>
        </div>
        <div className='actions'>
          <Button
            isDisabled={isDisabled}
            onClick={onDelete}
            skin={Button.SKIN.TEXT}
          >
            Delete
          </Button>
        </div>
      </div>
    </>
  )
}
